<div class="fluid-container js-teacher-message-form-{{id}}">
    <div class="col col8">
        <div class="activity-response teacher-response comment-form form-redux" id="replyForm-{{id}}">
            <div class="proposalMessageFormSubmissionErrors" id="proposalMessageFormSubmissionErrors-{{id}}"></div>
            <div class="titleAndMessage">
                <form method="post" id="addAMessageForm-{{id}}">

                    <div class="input-holder">
                        <div class="content" id="messageEdit-{{id}}">
                            <label for="message-{{id}}">Post a reply{{#if nameOfUserBeingRepliedTo}} to {{nameOfUserBeingRepliedTo}}{{/if}}</label>
                            <textarea name="message" id="message-{{id}}"></textarea>
                        </div>
                        <div class="content message-preview" id="messagePreview-{{id}}">
                            <div class="activity-response preview">
                                {{!-- Response section --}}
                                {{!-- Keep in sync with DonorProposalMessageForm --}}
                                {{{userAvatar author ''}}}
                                <div class="activity-description">
                                    <p>
                                        {{#if author.anonymous}}
                                            <strong>A donor</strong>
                                            {{#if author.state}}
                                                from {{author.state}}
                                            {{/if}}
                                        {{else}}
                                            {{#if author.teacherScreenName}}
                                                {{author.teacherScreenName}}
                                            {{else}}
                                                {{#if author.familiarDonorGreeting}}
                                                    {{author.familiarDonorGreeting}}
                                                    {{~else~}}
                                                    A donor
                                                {{~/if~}}{{locationAndDonorTeacherRelationship author true undefined}}
                                            {{/if}}
                                        {{/if}}
                                        {{#if teacherResponse}}
                                            responded
                                        {{/if}}
                                    </p>
                                </div>
                                {{!-- End response section --}}
                                <div class="comment">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="input-holder inline-button reply-action-wrapper" id="submitHolder">
                        <div id="buttonList-{{id}}">
                            <div class="pleaseReview" id="pleaseReview-{{id}}"><p class="text-discreet">Please review your message above. After you publish, you will not be able to edit or remove your message.</p></div>
                            <input type="submit" class="button-primary small publish-button js-publish" name="publish" data-id="{{id}}" id="publish-{{id}}" value="Publish" disabled="true" />
                            <input type="submit" class="button-primary small js-preview" name="submit" data-id="{{id}}" id="submit-{{id}}" value="Preview" />
                            <input type="submit" class="button-secondary small edit-teacher-message-button js-edit" name="edit" data-id="{{id}}" id="edit-{{id}}" value="Edit" />
                            <input type="submit" class="button-secondary small js-discard" name="discard" data-id="{{id}}" id="discard-{{id}}" value="Cancel" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
